import { Injectable, inject } from '@angular/core';
import { take } from 'rxjs/operators';
import { UserSessionService } from '../login/data-services/user-session/user-session.service';
import { LogoutService } from '../logout/logout.service';
import { LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  loggingService: LoggingService = inject(LoggingService);
  logoutService: LogoutService = inject(LogoutService);
  userSessionService: UserSessionService = inject(UserSessionService);
  refreshURL = '';

  logOutAndRedirect(slimHeaderLogoUrl: string): void {
    if (this.refreshURL === undefined || this.refreshURL === null) {
      this.refreshURL = window.location.pathname.includes('delta-vacation')
        ? slimHeaderLogoUrl
        : this.refreshURL;
      this.logoutService.logOut(this.refreshURL, false);
    } else {
      this.logoutService.logOut();
    }
  }

  keepMeLoggdIn(): void {
    this.userSessionService.getUserSession(true).pipe(take(1)).subscribe();
  }
}
